module.exports = __webpack_public_path__ + "static/media/realtimerounded-black.39d8afee.woff";